import { render, staticRenderFns } from "./HelpSidebar.vue?vue&type=template&id=ed6e42ec&"
import script from "./HelpSidebar.vue?vue&type=script&lang=js&"
export * from "./HelpSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports